"use strict";
var alert_component_1 = require('./alert/alert.component');
exports.AlertComponent = alert_component_1.AlertComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/alert.js
 ** module id = 686
 ** module chunks = 0
 **/